import { generatePath } from 'react-router-dom'

export enum AppRoute {
  Root = '/',
  ChatDebug = '/chat-debug',
  ChatDebugSupport = '/chat-debug/support',
  ChatDebugAssistant = '/chat-debug/assistant',
  LegacyDebug = '/debug/:id',
  Debug = '/debug',
  DebugV2 = '/debug-v2',
  AssistantPlayground = '/assistant-playground',
}

export const getRootRoute = () => generatePath(AppRoute.Root)
export const getChatDebugRoute = () => generatePath(AppRoute.ChatDebug)
export const getChatDebugSupportRoute = () => generatePath(AppRoute.ChatDebugSupport)
export const getChatDebugAssistantRoute = () => generatePath(AppRoute.ChatDebugAssistant)
export const getLegacyDebugRoute = (id: string) =>
  generatePath(AppRoute.LegacyDebug, { id })
export const getDebugRoute = (correlationId: string) =>
  `${generatePath(AppRoute.Debug)}?correlationId=${correlationId}`
export const getDebugRouteV2 = (correlationId: string) =>
  `${generatePath(AppRoute.DebugV2)}?correlationId=${correlationId}`
export const getAssistantPlaygroundRoute = () =>
  generatePath(AppRoute.AssistantPlayground)
